import React, { useState, useEffect } from "react";
import { BrowserRouter as Router, Routes, Route, Navigate } from "react-router-dom";
import { Toaster } from 'react-hot-toast'; 
import Login from "./pages/Login";
import Layout from "./components/Layout"; 
import ProtectedRoute from "./components/ProtectedRoute"; 
import { WebDataProvider } from "./context/WebDataContext";

// Pages
import Dashboard from "./pages/Dashboard";
import PendingApprovals from "./pages/PendingApprovals";
import Attendance from "./pages/Attendance";
import Tasks from "./pages/Tasks";
import Leaves from "./pages/Leaves";
import Expenses from "./pages/Expenses";
import Advances from "./pages/Advances";
import Travel from "./pages/Travel";
import CardRequests from "./pages/CardRequests";
import Catalogs from "./pages/Catalogs";
import Leads from "./pages/Leads";
import Reports from "./pages/Reports";
import Orders from "./pages/Orders";
import Demos from "./pages/Demos";
import Activity from "./pages/Activity";
import Organizations from "./pages/Organizations";
import Installations from "./pages/Installations";
import ServiceReports from "./pages/ServiceReports";
import ServiceCalls from "./pages/ServiceCalls";
import PMS from "./pages/PMS";
import SpareParts from "./pages/SpareParts";
import Couriers from "./pages/Couriers";
import Settings from "./pages/Settings";
import Timeline from "./pages/Timeline";
import PaymentDues from "./pages/PaymentDues";
import PaymentCollections from "./pages/PaymentCollections";
import SalesAnalysis from "./pages/SalesAnalysis";
import ManageUsers from "./pages/ManageUsers";
import MapView from "./pages/MapView";
import AssetHistory from "./pages/AssetHistory";
import OrgHistory from "./pages/OrgHistory";
import EmpHistory from "./pages/EmpHistory";
import ManagePermissions from "./pages/ManagePermissions";
import Profile from "./pages/Profile"; 
import AmcManager from "./pages/AmcManager";
import CalendarPlanner from "./pages/CalendarPlanner";

function App() {
  const [isAuth, setIsAuth] = useState(false);
  const [notificationCount, setNotificationCount] = useState(0);

  useEffect(() => {
    const loggedIn = sessionStorage.getItem("isAuth");
    if(loggedIn === "true") setIsAuth(true);
  }, []);

  // 🔥 ADDED LOGOUT FUNCTION
  const handleLogout = () => {
      setIsAuth(false);
      sessionStorage.removeItem("isAuth");
  };

  return (
    <Router>
      <Toaster position="top-center" reverseOrder={false} />
      <WebDataProvider>
        <Routes>
          {/* 1. PUBLIC ROUTE (Login) */}
          <Route path="/login" element={<Login setIsAuth={setIsAuth} />} />

          {/* 2. PROTECTED ROUTES (Sidebar + Layout) */}
          {isAuth ? (
            <Route path="/*" element={
              <ProtectedRoute>
                {/* 🔥 PASS LOGOUT & NOTIFICATION HERE */}
                <Layout onLogout={handleLogout} notificationCount={notificationCount}>
                  <Routes>
                    <Route path="/" element={<Dashboard setNotificationCount={setNotificationCount} />} />
                    
                    {/* DASHBOARD & BASICS */}
                    <Route path="/calendar" element={<CalendarPlanner />} />
                    <Route path="/amc" element={<AmcManager />} />
                    <Route path="/attendance" element={<Attendance />} />
                    <Route path="/tasks" element={<Tasks />} />
                    <Route path="/timeline" element={<Timeline />} />
                    <Route path="/pending-approvals" element={<PendingApprovals />} />

                    {/* HR & EXPENSES */}
                    <Route path="/leaves" element={<Leaves />} />
                    <Route path="/expenses" element={<Expenses />} />
                    <Route path="/advances" element={<Advances />} />
                    <Route path="/travel" element={<Travel />} />
                    <Route path="/card-requests" element={<CardRequests />} />

                    {/* SALES */}
                    <Route path="/leads" element={<Leads />} />
                    <Route path="/orders" element={<Orders />} />
                    <Route path="/catalogs" element={<Catalogs />} />
                    <Route path="/reports" element={<Reports />} />
                    <Route path="/demos" element={<Demos />} />
                    <Route path="/activity" element={<Activity />} />
                    <Route path="/sales_analysis" element={<SalesAnalysis />} />

                    {/* SERVICE */}
                    <Route path="/pms" element={<PMS />} />
                    <Route path="/service-calls" element={<ServiceCalls />} />
                    <Route path="/service-reports" element={<ServiceReports />} />
                    <Route path="/installations" element={<Installations />} />
                    <Route path="/spare-parts" element={<SpareParts />} />
                    
                    {/* OPERATIONS */}
                    <Route path="/organizations" element={<Organizations />} />
                    <Route path="/couriers" element={<Couriers />} />
                    <Route path="/map-view" element={<MapView />} />
                    
                    {/* ACCOUNTS */}
                    <Route path="/payment-dues" element={<PaymentDues />} />
                    <Route path="/payment-collections" element={<PaymentCollections />} />

                    {/* HISTORY (360 Views) */}
                    <Route path="/asset-history" element={<AssetHistory />} />
                    <Route path="/org-history" element={<OrgHistory />} />
                    <Route path="/emp-history" element={<EmpHistory />} />

                    {/* ADMIN & SETTINGS */}
                    <Route path="/settings" element={<Settings />} />
                    <Route path="/users" element={<ManageUsers />} />
                    <Route path="/permissions" element={<ManagePermissions />} />
                    <Route path="/profile" element={<Profile />} />

                    {/* FALLBACK */}
                    <Route path="*" element={<Navigate to="/" />} />
                  </Routes>
                </Layout>
              </ProtectedRoute>
            } />
          ) : (
            // Agar login nahi hai to kisi bhi link se Login par bhejo
            <Route path="*" element={<Navigate to="/login" />} />
          )}
        </Routes>
      </WebDataProvider>
    </Router>
  );
}

export default App;